// ECOMM-15146: shared so admin Customize and marketplace's useBundlesEnabled() gate on the same
// flag. In packages/common, not packages/shared (frozen) -- see concierge-rollout.ts precedent.
export const BUNDLES_ROLLOUT_FLAG = 'consumer.ecomm.bundles.rollout';
